// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f052fa64","952":"d5b40be8"}[chunkId] + ".chunk.js";
};